import { graphql } from 'react-relay';

export const getTagFilteredListQuery = graphql`
    query getTagFilteredListQuery($input: TagsFilteredListInput!, $first: Int) {
        ...tagListFragment @arguments(input: $input, first: $first)
    }
`;
